<template>
  <div class="cs-studyAbroad-tuitionInfo">
    <div>
      <span class="cs-title">
        <span>{{dataIn.termName}}-学校学费信息</span>
      </span>
    </div>
    <el-form :model="tuitionData" ref="form" class="demo-ruleForm">
      <el-table v-loading="isLoading" row-key="Id" :data="tuitionData.TuitionDetails" :show-summary="true" :summary-method="getSummaries"
        @row-dblclick="onTableRowDblClick">
        <template v-if="!isReadonly" #append>
          <el-button type="text" size="medium" icon="el-icon-plus" @click="onAddTuitionDetail">添加新类型</el-button>
        </template>
        <el-table-column prop="Name" label="学费类型">
          <template #default="{row, $index}">
            <div v-if="row._isEditing">
              <el-form-item :ref="`TuitionDetails_${$index}_Name`" :prop="`TuitionDetails[${$index}].Name`" :rules="[
                {
                  required: true,
                  message: '学费类型不能为空',
                  trigger: 'blur'
                },
                {
                  max: 250,
                  message: '字符数超过最大限制',
                  trigger: 'blur'
                }
              ]">
                <el-input size="mini" placeholder="请输入名称" v-model="row.Name" />
              </el-form-item>
            </div>
            <span v-else>{{row.Name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="AmountCAD" label="学费(加币)">
          <template #default="{row, $index}">
            <el-form-item v-if="row._isEditing" :ref="`TuitionDetails_${$index}_AmountCAD`" :prop="`TuitionDetails[${$index}].AmountCAD`">
              <el-input size="mini" placeholder="请输入金额" v-model="row.AmountCAD" oninput="value=value.replace(/[^0-9.]/g,'')"
                onblur="value=!!value?value.toNumber().toFixedEx(2):null" />
            </el-form-item>
            <span v-else>{{Object.toCurrency(row.AmountCAD)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="AmountCNY" label="学费(人民币)">
          <template #default="{row, $index}">
            <el-form-item v-if="row._isEditing" :ref="`TuitionDetails_${$index}_AmountCNY`" :prop="`TuitionDetails[${$index}].AmountCNY`">
              <el-input size="mini" placeholder="请输入金额" v-model="row.AmountCNY" oninput="value=value.replace(/[^0-9.]/g,'')"
                onblur="value=!!value?value.toNumber().toFixedEx(2):null" />
            </el-form-item>
            <span v-else>{{Object.toCurrency(row.AmountCNY, GLOBAL.currencyType.CNY)}}</span>
          </template>
        </el-table-column>
        <el-table-column width="100">
          <template v-if="!isReadonly" #default="{row, $index}">
            <div v-if="row._isEditing">
              <el-button type="text" size="small" @click="onTuitionDetailSave(row, $index)">保存</el-button>
              <el-button type="text" size="small" @click="onTuitionDetailCancel(row, $index)">取消</el-button>
            </div>
            <div v-else>
              <el-button type="text" size="small" @click="onTuitionDetailEdit(row)">编辑</el-button>
              <el-button type="text" size="small" class="cs-redLabel" @click="onTuitionDetailRemove(row, $index)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>

<script>
import { guid } from "@/config/mUtils";
import {
  getStudyAbroadStudentTuition,
  saveStudyAbroadStudentTuitionDetail,
  removeStudyAbroadStudentTuitionDetail,
  changeStudyAbroadStudentTuitionPaid,
} from "@/service/studyAbroad.service";

const default_tuition = {
  Id: 0,
  StudentId: 0,
  TermId: 0,
  IsPaid: false,
  TuitionDetails: [],
};

const default_tuitionDetail = {
  Id: 0,
  TuitionId: 0,
  Name: null,
  AmountCAD: 0,
  AmountCNY: 0,
};

const mixin_generalMethods = {
  methods: {
    getSummaries({ columns, data }) {
      let sums = [];

      const h = this.$createElement;
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "学费总额";
          return;
        }

        if (index === 3) {
          if (!this.isReadonly) {
            sums[index] = h(
              "el-dropdown",
              {
                props: {
                  trigger: "click",
                },
                on: {
                  command: this.onPaidCommand,
                },
              },
              [
                h(
                  "span",
                  {
                    class: "el-dropdown-link",
                  },
                  [
                    h(
                      "span",
                      {
                        class: {
                          "cs-redLabel": !this.tuitionData.IsPaid,
                          "cs-color-green": this.tuitionData.IsPaid,
                        },
                      },
                      this.tuitionData.IsPaid ? "已缴付" : "未缴付"
                    ),
                    h(
                      "el-dropdown-menu",
                      {
                        slot: "dropdown",
                      },
                      [
                        h(
                          "el-dropdown-item",
                          {
                            class: "cs-redLabel",
                            props: {
                              command: 0,
                            },
                          },
                          "未缴付"
                        ),
                        h(
                          "el-dropdown-item",
                          {
                            class: "cs-color-green",
                            props: {
                              command: 1,
                            },
                          },
                          "已缴付"
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            );
          } else {
            sums[index] = h(
              "span",
              {
                class: {
                  "cs-redLabel": !this.tuitionData.IsPaid,
                  "cs-color-green": this.tuitionData.IsPaid,
                },
              },
              this.tuitionData.IsPaid ? "已缴付" : "未缴付"
            );
          }
          return;
        }

        let sumValue = data.sum((item) =>
          `${item[column.property]}`.toNumber()
        );
        let currencyType;
        switch (column.property) {
          case "AmountCNY":
            currencyType = this.GLOBAL.currencyType.CNY;
            break;
          default:
            currencyType = this.GLOBAL.currencyType.CAD;
            break;
        }
        sums[index] = Object.toCurrency(sumValue, currencyType);
      });

      return sums;
    },
    async validateRow(index) {
      return new Promise((resolve, reject) => {
        let vmForm = this.$refs.form;
        if (!vmForm) {
          resolve();
          return;
        }

        vmForm.validateField(
          [
            `TuitionDetails[${index}].Name`,
            `TuitionDetails[${index}].AmountCAD`,
            `TuitionDetails[${index}].AmountCNY`,
          ],
          (errMsg) => {
            if (!errMsg) resolve();
            else reject(new Error(errMsg));
          }
        );
      });
    },
    resetRow(index) {
      let vmField = this.$refs[`TuitionDetails_${index}_Name`];
      if (!!vmField) vmField.resetField();

      vmField = this.$refs[`TuitionDetails_${index}_AmountCAD`];
      if (!!vmField) vmField.resetField();

      vmField = this.$refs[`TuitionDetails_${index}_AmountCNY`];
      if (!!vmField) vmField.resetField();
    },
  },
};

export default {
  name: "tuitionInfo",
  mixins: [mixin_generalMethods],
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    dataIn: {
      termId: Number,
      termName: String,
      studentId: Number,
    },
  },
  data() {
    return {
      isLoading: false,
      tuitionData: Object.clone(default_tuition),
    };
  },
  created() {
    this.loadStudyAbroadStudentTuitionFromServer();
  },
  methods: {
    // 与服务端交互数据相关方法
    async loadStudyAbroadStudentTuitionFromServer() {
      if (!this.dataIn || !this.dataIn.studentId || !this.dataIn.termId) {
        this.tuitionData = Object.clone(default_tuition);
        return;
      }

      this.isLoading = true;
      try {
        let result = await getStudyAbroadStudentTuition(
          this.dataIn.studentId,
          this.dataIn.termId
        );
        this.tuitionData =
          !!result && result.success && !!result.data
            ? result.data
            : Object.clone(default_tuition);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async saveStudyAbroadStudentTuitionDetailToServer(row) {
      this.isLoading = true;
      try {
        let saveData = Object.clone(row, {
          exceptFields: ["_isEditing", "_isNew"],
        });
        if (row._isNew) {
          saveData.Id = 0;
        }

        let result = await saveStudyAbroadStudentTuitionDetail(saveData);
        if (!!result && result.success && result.data) {
          this.$message.success("保存学费明细成功");

          await this.loadStudyAbroadStudentTuitionFromServer();
        } else {
          this.$message.error("保存学费明细失败");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async removeStudyAbroadStudentTuitionDetailToServer(id) {
      this.isLoading = true;
      try {
        let result = await removeStudyAbroadStudentTuitionDetail(id);
        if (!!result && result.success && result.data) {
          this.$message.success("删除学费明细成功");

          await this.loadStudyAbroadStudentTuitionFromServer();
        } else {
          this.$message.error("删除学费明细失败");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async changeStudyAbroadStudentTuitionPaidToServer(value) {
      this.isLoading = true;
      try {
        let result = await changeStudyAbroadStudentTuitionPaid(
          this.tuitionData.Id,
          value
        );
        if (!!result && result.success && result.data) {
          this.$message.success("修改学费缴费状态成功");
        } else {
          this.$message.error("修改学费缴费状态失败");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    onPaidCommand(cmdValue) {
      let newValue = !!cmdValue;
      if (newValue === this.tuitionData.IsPaid) return;

      this.tuitionData.IsPaid = newValue;
      this.changeStudyAbroadStudentTuitionPaidToServer(newValue);
    },
    onTableRowDblClick(row, column, event) {
      if (this.isReadonly || !column.property || row._isEditing) return;

      this.onTuitionDetailEdit(row);
    },
    onAddTuitionDetail() {
      let newTuitionDetail = Object.clone(default_tuitionDetail);
      newTuitionDetail.Id = guid();
      newTuitionDetail.TuitionId = this.tuitionData.Id;
      newTuitionDetail._isEditing = true;
      newTuitionDetail._isNew = true;
      this.tuitionData.TuitionDetails.push(newTuitionDetail);
    },
    onTuitionDetailEdit(row) {
      this.$set(row, "_isEditing", true);
    },
    onTuitionDetailRemove(row, index) {
      this.$confirm("您确认要删除该明细吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.removeStudyAbroadStudentTuitionDetailToServer(row.Id);
        })
        .catch(() => {});
    },
    onTuitionDetailSave(row, index) {
      row.AmountCAD = `${row.AmountCAD}`.toNumber();
      row.AmountCNY = `${row.AmountCNY}`.toNumber();

      this.validateRow(index)
        .then(() => {
          this.saveStudyAbroadStudentTuitionDetailToServer(row);
        })
        .catch((err) => {});
    },
    onTuitionDetailCancel(row, index) {
      if (row._isNew) {
        this.tuitionData.TuitionDetails.remove(row);
        return;
      }

      this.resetRow(index);

      row._isEditing = false;
    },
  },
  watch: {
    dataIn(newVal) {
      this.loadStudyAbroadStudentTuitionFromServer();
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-studyAbroad-tuitionInfo {
  .el-table {
    th > .cell {
      word-break: break-word;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/academicInfo/tuitionInfo.vue